// import { encryptStorage } from '@/utils/storage';
import { apiClient, apiOfficialClient } from './config.js';
import { apiClientPbx } from '@/api/sipmovil_auth_api.js'
import { apiClient as apiClientSoftphone } from '@/api/softphone_api.js'
import { encryptStorage } from '@/utils/storage';

export default {
  // conseguir los chats por usuario
  getChats(userName, page) {
    // envia el parametro owner si el usuario es agente
    const join = encryptStorage.getItem('user').join;
    let strOwner = '';
    if (join.isAdmin === false) {
      console.log('entro if');
      strOwner = `&owner=${userName}`;
    }
    return apiClient.get(`dialogs/?page=${page}${strOwner}`);
  },
  getChatsByMessages(characters, chatId = null) {
    const chatIdParam = chatId ? `&chatId=${chatId}` : '';
    return apiClientPbx.get(`api/chat/filter-messages/?characters=${characters}${chatIdParam}`);
  },
  getAllChatsByMessages(characters) {
    return apiClientPbx.get(`api/chat/filter-all-messages/?characters=${characters}`);
  },
  getJoinChatsByMessages(query, username, closed=false, chatId = null, agent = null) {
    const chatIdParam = chatId ? `&chatId=${chatId}` : '';
    const agentParam = agent ? `&agent=${agent}` : '';
    return apiOfficialClient.get(
      `search-messages-senders/?username=${username}&characters=${query}${chatIdParam}&closed=${closed}${agentParam}` // &page=${page}
    );
  },
  getJoinFilteredMessages(chat) {
    return apiOfficialClient.get(
      `get-filtered-messages/?chatId=${chat.chatId}&messageId=${chat.message[0]}`
    );
  },
  getChatsbyAgents(str, token, page, cursor = null, aditionalParams) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    let appendStr = '';
    if (cursor !== null && page !== 1) {
      appendStr += `&cursor=${cursor}`;
    }
    return apiOfficialClient.get(`senders_by_agent/?page=${page}&characters=${str}${aditionalParams}${appendStr}`);
  },
  getChatsbyLabels(str, token, owner, isAdmin, page, aditionalParams) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    let appendStr = '';
    if (isAdmin !== true) {
      appendStr = `&owner=${owner}`;
    }
    return apiOfficialClient.get(
      `senders_by_label/?page=${page}&labels_id=${str}${appendStr}${aditionalParams}`
    );
  },
  getChatsbyNoReply(token, owner, isAdmin, page, aditionalParams) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    let appendStr = '';
    if (isAdmin !== true) {
      appendStr = `&owner=${owner}`;
    }
    return apiOfficialClient.get(
      `senders_by_no_reply/?page=${page}${appendStr}${aditionalParams}`
    );
  },
  getChatsbyUnread(token, owner, isAdmin, page, agrupedView) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    let appendStr = '';
    if (isAdmin !== true) {
      appendStr = `&owner=${owner}`;
    }
    return apiOfficialClient.get(
      `senders_by_unread/?page=${page}${appendStr}&agruped_view=${agrupedView}`
    );
  },
  getFilteredSenders(token, owner, isAdmin, page, cursor=null, aditionalParams='') {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    let appendStr = '';
    if (isAdmin !== true) {
      appendStr = `&owner=${owner}`;
    }
    if (cursor !== null && page !== 1) {
      appendStr += `&cursor=${cursor}`;
    }
    return apiOfficialClient.get(
      `filtered-senders/?page=${page}${appendStr}${aditionalParams}`
    );
  },
  // conseguir o crear un chat de acuerdo a un nombre de contacto
  getOrCreateChat(userName, token, contactName) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.post(
      `new_dialog/?username=${userName}&phone=${contactName}`
    );
  },
  // transferir una conversacion a un agente
  transferChat(groupName, chatId, agentName) {
    const userName = encryptStorage.getItem('user').Username;
    return apiClient.put(
      `update_dialog/?chat_id=${chatId}&owner=${agentName}&group_name=${groupName}&agent_name=${userName}`
    );
  },
  // conseguir los dialogos de una persona que actualmente esta usando
  // whatsapp oficial por el proveedor gupshup
  getSenders(page, token, owner, isAdmin, cursor = null, orderByState = false) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    let appendStr = `&orderByState=${orderByState}`;
    if (isAdmin !== true) {
      appendStr += `&owner=${owner}`;
    }
    if (cursor !== null && page !== 1) {
      appendStr += `&cursor=${cursor}`;
    }
    return apiOfficialClient.get(`senders/?page=${page>0 ? page : 1 }${appendStr}`);
  },
  getSipmovilSenders() {
    // return apiClientPbx.get(`api/v1/people/`);
    return apiClientPbx.get(`api/v1/chats/`);
  },
  getSipmovilStatusSenders() {
    // return apiClientPbx.get(`api/v1/people/`);
    return apiClientPbx.get(`api/webrtc/pjsip_contacts`);
  },
  createSipmovilSender(users, name = "", onlyAdminsMessages=false, isGroup=false) {
    return apiClientPbx.post(`api/chat/create-chat/`, {
      'users': users,
      'name': name,
      'onlyAdminsMessages': onlyAdminsMessages,
      'is_group': isGroup,
    });
  },
  editGroupSipmovil(formData) {
    return apiClientPbx.post(`api/chat/edit-chat-groupadmin/`, formData);
  },
  createFexIAProject(data) {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('prompt', data.prompt);
    (data.files || []).forEach(file => formData.append('files', file));
    return apiClientPbx.post(`api/chat/create-fexia-project/`, formData);
  },
  createFexIASender(data) {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('project_id', data.project_id);
    return apiClientPbx.post(`api/chat/create-fexia-chat/`, formData);
  },
  editFexIASender(data) {
    const formData = new FormData();
    formData.append('chat_id', data.chat_id);
    formData.append('name', data.name);
    formData.append('prompt', data.prompt);
    (data.files || []).forEach(file => formData.append('files', file));
    return apiClientPbx.post(`api/chat/create-fexia-chat/`, formData);
  },
  deleteFexIAChat(chat_id) {
    return apiClientPbx.post(`api/chat/delete-fexia-chat/`, {
      "chat_id": chat_id,
    });
  },
  shareFexIAProject(data) {
    return apiClientPbx.post(`api/chat/share-fexia-project/`, {
      project_id: data.project_id,
      user_ids: data.user_ids,
    });
  },
  getFexIAProjectData(chatId) {
    return apiClientPbx.get(`api/chat/chat_data_fexia/${chatId}/`);
  },
  getFexIAProject(projectId) {
    return apiClientPbx.get(`api/chat/get-fexia-projects/`, { params: { project_id: projectId } });
  },
  updateFexIAProject(data) {
    const formData = new FormData();
    formData.append('project_id', data.project_id);
    if (data.name !== undefined) formData.append('name', data.name);
    if (data.prompt !== undefined) formData.append('prompt', data.prompt);
    const keepIds = data.keep_file_ids || [];
    keepIds.forEach(id => formData.append('keep_file_ids', id));
    if (keepIds.length === 0) {
      formData.append('keep_file_ids', '-1');
    }
    (data.files || []).forEach(file => formData.append('files', file));
    return apiClientPbx.post('api/chat/update-fexia-project/', formData);
  },
  getCompanyUsers() {
    return apiClientSoftphone.get(`/api/crm/users_sipmovil/?limit=1000&active=true`);
  },
  // transferir una conversacion a un agente API oficial
  transferSender(groupName, senderId, agentName, token, finishChat, message) {
    const userName =encryptStorage.getItem('user').Username;
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    const agent = userName;
    return apiOfficialClient.put(
      `update_sender/?chat_id=${senderId}&owner=${agentName}&group_name=${groupName}&agent_name=${agent}&finish=${finishChat}`, {
        message,
      }
    );
  },
  updateLabel(senderId, labelId, token) {
    const userName = encryptStorage.getItem('user').Username;
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.put(
      `update_sender/?chat_id=${senderId}&label_id=${labelId}&agent=${userName}`
    );
  },
  updateUnread(token, sender) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.put(
      `update_sender/?chat_id=${sender.id}&unread=${sender.unread}`
    );
  },
  banChat(token, sender, user) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.post(
      `ban-sender/?chat_id=${sender.id}&username=${user}`
    );
  },
  unblockChat(token, sender, user) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.post(
      `unblock-sender/?chat_id=${sender.id}&username=${user}`
    );
  },
  // Recargar configuaciones del bot
  reloadBot(token) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.post('reload_bot/');
  },
  endAgentConversations(agentName, token) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.post(`close-agent-conversations/?owner=${agentName}`);
  },
  transferAgentConversations(currentOwner, newOwner, token) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.post(`transfer-agent-conversations/?current_owner=${currentOwner}&new_owner=${newOwner}`);
  },
  // FEX-1162: transferencia selectiva de un conjunto de conversaciones a un agente
  transferConversations(payload, token) {
    apiOfficialClient.interceptors.request.use((config) => {
      config.headers = {
        Authorization: `Token ${token}`,
      };
      return config;
    });
    return apiOfficialClient.post('transfer-conversations/', payload);
  },
  // Transferencia selectiva: finalización en bloque de las conversaciones
  // seleccionadas.
  // Los headers van POR PETICIÓN, no con `interceptors.request.use()` como los
  // métodos vecinos: ese patrón acumula un interceptor por llamada que nunca se
  // elimina, y al hacer `config.headers = {...}` (asignación, no merge) borra los
  // defaults `Accept` y `Content-Type: application/json` de la instancia.
  finishConversations(payload, token) {
    return apiOfficialClient.post('finish-conversations/', payload, {
      headers: { Authorization: `Token ${token}` },
    });
  },
  getPjsipContacts(endpoint) {
    return apiClientPbx.post(`/api/webrtc/pjsip_contact`, { 'endpoint': endpoint });
  },
  createGroup(endpoint) {
    return apiClientPbx.post(`start/`, { 'endpoint': endpoint });
  },
  updateProfileConfig(data) {
    return apiClientPbx.post(`api/webrtc/update-profile-config/`, data);
  },
  getNotifications() {
    return apiClientPbx.get(`api/admin/notifications/`);
  },
  getReadNotifications() {
    return apiClientPbx.get(`api/webrtc/read_notifications`);
  },
  readNotifications(data) {
    return apiClientPbx.post(`api/webrtc/read_notifications`, data);
  },
  readAllNotifications() {
    return apiClientPbx.post(`api/webrtc/read_notifications`, { mark_all: true });
  },
  quitOfGroupRequest(id) {
    return apiClientPbx.post(`api/chat/participant_leave_chat/${id}/`);
  },
  leaveAndDeleteGroupRequest(id) {
    return apiClientPbx.post(`api/chat/participant_leave_and_delete_chat/${id}/`);
  },
  updatePinChat(data) {
    return apiClientPbx.post('api/chat/pin-chat/', data)
  },
  getClosingTypes() {
    return apiClientSoftphone.get('api/whatsapp/closing_types/');
  },
  getSipmovilFilteredMessages(chat) {
    return apiClientPbx.get(`api/chat/get-filtered-messages/?chatId=${chat.chatId}&messageId=${chat.messageId || chat.message[0]}`);
  },
  bulkDownloadConversations(payload) {
    return apiClientSoftphone.post('api/whatsapp/bulk_download_conversations/', payload);
  },
  getBulkDownloadStatus() {
    return apiClientSoftphone.get('api/whatsapp/bulk_download_conversations/status/');
  },
  // FEX-1157: velocidad de reproducción de notas de voz (preferencia global por
  // usuario). El backend la nombra `speed` (valores 1 | 1.5 | 2). Mismo prefijo
  // api/chat/ que reminders/pin-chat (el doc lo llama chat_api/ internamente).
  getAudioPlaybackSpeed() {
    return apiClientPbx.get('api/chat/audio-playback-speed/');
  },
  updateAudioPlaybackSpeed(speed) {
    return apiClientPbx.post('api/chat/audio-playback-speed/update/', { speed });
  },
};
